import cloneDeep from 'clone-deep';

// eslint-disable-next-line import/prefer-default-export
export function clone(value) {
  return cloneDeep(value);
}
